import { render, staticRenderFns } from "./TunnelComponent.vue?vue&type=template&id=56b9b2b3&"
import script from "./TunnelComponent.vue?vue&type=script&lang=js&"
export * from "./TunnelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports